import { render, staticRenderFns } from "./Tellme.vue?vue&type=template&id=780d0072&scoped=true&"
import script from "./Tellme.vue?vue&type=script&lang=js&"
export * from "./Tellme.vue?vue&type=script&lang=js&"
import style0 from "./Tellme.vue?vue&type=style&index=0&id=780d0072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780d0072",
  null
  
)

export default component.exports